import { css, StyleDeclarationValue, StyleSheet } from 'aphrodite';
import { useMemo } from 'react';
import { styleSheet } from './styles';

interface IProps {
	cardStyles?: StyleDeclarationValue[];
	className?: string;
	contentStyles?: StyleDeclarationValue[];
	customFooterHtml?: string;
	customHeaderHtml?: string;
	hasCustomFooter?: boolean;
	hasCustomHeader?: boolean;
	renderCustomHtml?: (html: string, htmlClassName: string) => React.ReactNode;
	styles?: StyleDeclarationValue[];
	wrapperStyles?: StyleDeclarationValue[];
	children: React.ReactNode;
}

const defaultRenderCustomHtml = (html: string, htmlClassName: string) => {
	return <div className={htmlClassName} dangerouslySetInnerHTML={{ __html: html }} />;
};

export const MeetingContainerView: React.FC<IProps> = ({
	cardStyles = [],
	children,
	className = '',
	contentStyles = [],
	customFooterHtml,
	customHeaderHtml,
	hasCustomFooter,
	hasCustomHeader,
	renderCustomHtml = defaultRenderCustomHtml,
	styles = [],
	wrapperStyles = [],
}) => {
	const flattenTopCorners = hasCustomHeader ?? !!customHeaderHtml;
	const flattenBottomCorners = hasCustomFooter ?? !!customFooterHtml;

	const dynamicContentStyles = useMemo(() => {
		const borderRadiusStyles: any = {};

		if (flattenTopCorners) {
			borderRadiusStyles.borderTopLeftRadius = 0;
			borderRadiusStyles.borderTopRightRadius = 0;
		}

		if (flattenBottomCorners) {
			borderRadiusStyles.borderBottomLeftRadius = 0;
			borderRadiusStyles.borderBottomRightRadius = 0;
		}

		// Only create styles if there are actual style properties
		if (Object.keys(borderRadiusStyles).length > 0) {
			return StyleSheet.create({ dynamic: borderRadiusStyles }).dynamic;
		}
		return null;
	}, [flattenTopCorners, flattenBottomCorners]);

	return (
		<div className={css(styleSheet.fullHeightWrapper, ...wrapperStyles)}>
			{customHeaderHtml ? renderCustomHtml(customHeaderHtml, css(styleSheet.customHeader)) : null}
			<div className={`meeting-container ${className} ${css(styleSheet.container, ...(styles || []))}`}>
				<div className={css(styleSheet.content, ...(cardStyles || []))}>
					<div className={css(styleSheet.body, ...[dynamicContentStyles, ...(contentStyles || [])].filter(Boolean))}>
						{children}
					</div>
				</div>
			</div>
			<div className={css(styleSheet.footer)}>
				{customFooterHtml ? renderCustomHtml(customFooterHtml, css(styleSheet.customFooter)) : null}
			</div>
		</div>
	);
};
